// extracted by mini-css-extract-plugin
export default {"textMargin":"BasicInfo_textMargin__3PiE2","container":"BasicInfo_container__b5B54","wrapper":"BasicInfo_wrapper__aEvuY","formItem":"BasicInfo_formItem__bHHnF"};